// extracted by mini-css-extract-plugin
export default {"footerLinksWrapper":"_FooterLinks_footerLinksWrapper__F17ZL"};